import { setAuthenticated } from "@/redux/auth/authSlice";
import { store } from "@/store/store";

export const onRequest = (config) => {
  // we can attach auth tokens and trace IDs here
  //   console.log("🔄 [Request]", config.method?.toUpperCase(), config.url);
  return config;
};

export const onRequestError = (error) => {
  //   console.error("❌ [Request Error]", error);
  return Promise.reject(error);
};

export const onResponse = (response) => {
  //   console.log("✅ [Response]", response.config.url, response.status);

  if (response.data?.status === "SESSION_REQUIRED") {
    console.warn(
      "⚠️ Session required. Handle logout or re-authentication here."
    );
    store.dispatch(setAuthenticated(false));
    // Optional: dispatch logout, redirect, etc.
  } else if (response.data?.status === "AUTH_REQUIRED") {
    console.warn(
      "⚠️ Authentication required. Handle login or re-authentication here."
    );
    store.dispatch(setAuthenticated(false));
    // Optional: dispatch logout, redirect, etc.
  } else if (
    response.status === 200 &&
    response.config.url === "/portal/signIn" &&
    response.data.status === "SUCCESS"
  ) {
    store.dispatch(setAuthenticated(true));
  }

  return response;
};

export const onResponseError = (error) => {
  if (error?.code === "ERR_CANCELED") {
    console.warn("⚠️ Request was cancelled.");
    return Promise.reject(error);
  }

  const { response } = error;

  if (response) {
    console.error("❌ [Response Error]", response.status, response.config.url);

    // Handle specific HTTP status codes
    switch (response.status) {
      case 401:
        console.warn(
          "⚠️ Unauthorized. Handle logout or re-authentication here."
        );
        store.dispatch(setAuthenticated(false));
        break;
      case 403:
        console.warn("⚠️ Forbidden. Handle permission issues here.");
        break;
      case 404:
        console.warn("⚠️ Resource not found.", response.config.url);
        break;
      case 500:
        console.error(
          "⚠️ Internal Server Error.",
          response.data?.message || "Unknown server error"
        );
        break;
      default:
        console.error("⚠️ Unhandled error status:", response.status);
    }
  } else {
    console.error("❌ [Network Error]", error.message);
  }

  return Promise.reject(error);
};
